import {
  // instanceOf,
  PropTypes,
} from "prop-types";
import React, { Component } from "react";
// import { Cookies, withCookies } from "react-cookie";
import { connect } from "react-redux";
import { Redirect, withRouter } from "react-router";
import CookieHelper from "./Helpers/Cookies";
import { saveUser, updateUser } from "./Redux/actions/userActions";
import Axios from "axios";
// import Error from "./Views/Admin/Components/Error";
// import log from "loglevel";
import Loading from "./Views/Admin/Components/Loading";
import ConsentGate from "./Views/Admin/Components/ConsentGate";
import { isHubEmbedded, notifyHubSessionExpired } from "./Helpers/hubEmbed";

var jwtDecode = require("jwt-decode");

class LoginCheck extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
      // Help consent gate (lou#11). null = not yet checked; [] = cleared/none
      // required; a non-empty array = agreements the user must accept first.
      consentRequired: null,
      consentAccepting: false,
      consentError: null,
      // Digadop 2.0: true while embedded in the hub and waiting for the hub to
      // post the session (instead of showing the standalone login).
      awaitingHubSession: false,
      // Digadop 2.0: the hub never posted a session within the timeout window,
      // so show a retry instead of an indefinite "Connecting" spinner.
      hubConnectTimedOut: false,
    };
    this.acceptConsent = this.acceptConsent.bind(this);
  }

  // Digadop 2.0: start (or restart) the wait-for-hub-session timeout. If the hub
  // has not authenticated us within the window, surface a retry.
  startHubConnectTimer() {
    if (this.hubTimer) {
      clearTimeout(this.hubTimer);
    }
    this.setState({ hubConnectTimedOut: false });
    this.hubTimer = setTimeout(() => {
      const ud = this.props.user && this.props.user.userData;
      if (!(ud && ud.token)) {
        this.setState({ hubConnectTimedOut: true });
      }
    }, 8000);
  }

  componentWillUnmount() {
    if (this.hubTimer) {
      clearTimeout(this.hubTimer);
    }
    if (this.interval) {
      clearTimeout(this.interval);
    }
  }

  componentDidMount() {
    // #336: the dead, fully-commented checkVersion() that used to live here hit
    // the known-stale /serverversion endpoint and did nothing. Force-upgrade is
    // now owned end-to-end by startVersionCheck() (Helpers/versionCheck.js),
    // which polls the no-cache /version.json and forces a reload on mismatch.
    this.updateLogin();
  }

  checkForUpdates() {
    Axios.get("https://" + process.env.REACT_APP_API + "/checkforupdates/", {
      headers: { jwttoken: this.props.user.userData.token },
    })
      .then((success) => {
        // success.data.user.roleId = success.data.user.RoleId
        this.props.updateUser(success.data.user);
        // log.debug("API Response:", success);
      })
      .catch((error) => {
        if (error.response) {
          // log.error("API Error:", error);
          if (
            error.response.status === 401 &&
            error.response.data.message === "Unauthorized User"
          ) {
            // Digadop 2.0: inside the hub the app must not bounce to its own
            // login-error page on an expired token. Ask the hub to re-mint and
            // wait for a fresh session (HubBridge will accept it) instead.
            if (isHubEmbedded()) {
              notifyHubSessionExpired();
              this.setState({ awaitingHubSession: true });
              this.startHubConnectTimer();
            } else {
              this.setState({ error: true });
            }
          }
        }
      });
  }

  // Help consent gate (lou#11). Ask dbServer (which proxies Lou) whether this
  // user/org still owes acceptance of a required agreement. Fail OPEN on any
  // transport/availability error (e.g. Lou 503 not-configured, a 502 blip): a
  // consent-service hiccup must not lock admins out of Help. We gate ONLY on an
  // explicit cleared:false. Lou's append-only ledger means a gate missed during
  // an outage is simply re-prompted on the next load.
  checkConsent(token) {
    Axios.get("https://" + process.env.REACT_APP_API + "/consent/status", {
      headers: { jwttoken: token },
    })
      .then(({ data }) => {
        if (data && data.cleared === false && Array.isArray(data.required)) {
          this.setState({ consentRequired: data.required });
        } else {
          this.setState({ consentRequired: [] });
        }
      })
      .catch(() => {
        // fail open -- do not block the app if consent status is unavailable
        this.setState({ consentRequired: [] });
      });
  }

  acceptConsent() {
    const token = this.props.user.userData && this.props.user.userData.token;
    const required = this.state.consentRequired || [];
    if (!token || required.length === 0) return;
    this.setState({ consentAccepting: true, consentError: null });
    Promise.all(
      required.map((a) =>
        Axios.post(
          "https://" + process.env.REACT_APP_API + "/consent/accept",
          { agreementId: a.agreementId, version: a.version },
          { headers: { jwttoken: token } }
        )
      )
    )
      .then(() => {
        // every required agreement recorded -> open the app
        this.setState({ consentRequired: [], consentAccepting: false });
      })
      .catch((err) => {
        const msg =
          (err.response &&
            err.response.data &&
            err.response.data.message) ||
          "Could not record your acceptance. Please try again.";
        this.setState({ consentAccepting: false, consentError: msg });
      });
  }

  updateLogin() {
    let cookieKey;
    let query = this.props.router.query;
    // #282: decide which account is active.
    // Inside the Salesforce LWC iframe the ?OrganizationId=&UserId= params are
    // authoritative -- the embedder tells the app which (org, user) to be, and
    // they are present on every load. Standalone (the app opened as a top-level
    // tab, e.g. the multi-account admin dashboard) the cur_user cookie is
    // authoritative: a stale ?OrganizationId=&UserId= left in the address bar
    // from a prior session must NOT silently swap the active account on refresh
    // (the bug: add account B -> refresh -> reverted to the previous user).
    const embedded = window.self !== window.top;
    const queryKey =
      query.OrganizationId && query.UserId
        ? query.OrganizationId + "." + query.UserId
        : null;
    const curUser = CookieHelper.getCookie("cur_user");
    if (embedded && queryKey && CookieHelper.getCookie(queryKey)) {
      // iframe deep-link select (the org/user the LWC asked for)
      cookieKey = queryKey;
      CookieHelper.setCookie("cur_user", cookieKey);
    } else if (curUser && CookieHelper.getCookie(curUser)) {
      // an active session wins -> no revert on refresh
      cookieKey = curUser;
    } else if (queryKey && CookieHelper.getCookie(queryKey)) {
      // standalone first load / deep link with no active session yet
      cookieKey = queryKey;
      CookieHelper.setCookie("cur_user", cookieKey);
    } else {
      this.redirectToLogin();
      return;
    }
    if (cookieKey) {
      // #338: a corrupt/legacy account cookie (bad JSON, or a token jwt-decode
      // chokes on) used to throw here. With no error boundary above this, the
      // throw blanked the screen instead of sending the user to login. Guard
      // both the parse and the decode; on any failure, drop the bad cookie and
      // route to login so the user can re-authenticate cleanly.
      let user;
      let exp;
      try {
        user = JSON.parse(CookieHelper.getCookie(cookieKey));
        exp = jwtDecode(user.token).exp;
      } catch (err) {
        CookieHelper.deleteCookie(cookieKey);
        this.redirectToLogin();
        return;
      }
      // log.debug("Logged in User Details:", user);
      let now = new Date().getTime() / 1000;
      if (exp < now) {
        this.redirectToLogin();
      } else {
        this.props.saveUser(user);
        this.checkConsent(user.token);
        this.interval = setTimeout(() => {
          if (this.props.user.userData.token) {
            this.checkForUpdates();
          }
        }, 100);
      }
    } else {
      this.redirectToLogin();
    }
  }

  redirectToLogin() {
    // Digadop 2.0: inside the hub the app never shows its own Salesforce login.
    // The hub owns auth and pushes the session over postMessage (HubBridge). If
    // no session is present yet, stay on a loading state and wait for it rather
    // than flashing the standalone login card.
    if (
      isHubEmbedded() &&
      !(
        this.props.user &&
        this.props.user.userData &&
        this.props.user.userData.token
      )
    ) {
      this.setState({ awaitingHubSession: true });
      this.startHubConnectTimer();
      return;
    }
    let prevRouter = this.props.router;
    if (this.props.router.pathname.includes("/login")) {
      prevRouter = null;
    }
    this.props.history.push({
      pathname: "/login",
      search: this.props.router.search,
      state: { prevRouter: prevRouter },
    });
    // this.setState({ redirectToLogin: true }, () => { });
  }

  render() {
    if (this.state.error !== false) {
      return <Redirect to={{ pathname: "/login/error" }} />;
    }
    // Digadop 2.0: embedded and no session yet -> wait for the hub, do not show
    // the standalone login. HubBridge saves the hub-posted session, which
    // re-renders this with a token and drops through to the routed views.
    if (
      this.state.awaitingHubSession &&
      !(this.props.user.userData && this.props.user.userData.token)
    ) {
      if (this.state.hubConnectTimedOut) {
        return (
          <div className="loginLoader">
            <h1>Could not connect to Digadop Hub</h1>
            <p className="text-muted">
              We did not receive a session from the hub. Please try again.
            </p>
            <button
              className="btn btn-primary"
              onClick={() => window.location.reload()}
            >
              Retry
            </button>
          </div>
        );
      }
      return <Loading message="Connecting to Digadop Hub" />;
    }
    // Help consent gate (lou#11): block the app behind an opaque modal until the
    // org admin accepts the required agreement(s). react-modal portals over the
    // routed content, so returning only the gate here is enough to block it.
    if (
      this.props.user.userData &&
      this.state.consentRequired &&
      this.state.consentRequired.length > 0
    ) {
      return (
        <ConsentGate
          agreements={this.state.consentRequired}
          accepting={this.state.consentAccepting}
          error={this.state.consentError}
          onAccept={this.acceptConsent}
        />
      );
    }
    if (this.props.router.pathname === "/" && this.props.user.userData) {
      if (this.props.router.query.source) {
        return (
          <Redirect
            to={{ pathname: "/learn", search: this.props.router.search }}
          />
        );
      } else {
        return (
          <Redirect
            to={{
              pathname: "/admin/dashboard",
              search: this.props.router.search,
            }}
          />
        );
      }
    } else if (this.props.user.userData) {
      return null;
    } else {
      return <Loading message="Checking Login" />;
    }
  }
}

LoginCheck.propTypes = {
  user: PropTypes.object.isRequired,
  saveUser: PropTypes.func.isRequired,
  updateUser: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user,
  router: state.router.location,
});

export default withRouter(
  connect(mapStateToProps, { saveUser, updateUser })(LoginCheck)
);
